import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibTextarea } from '@chewy/kib-fields-new-react'
import { KibModal } from '@chewy/kib-overlays-react'
import classNames from 'classnames'

import '@chewy/kib-overlays-styles/dist/styles/kib-modal.css'
import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import '@chewy/kib-fields-new-styles/dist/styles/kib-field.css'
import styles from './prescriptionDeclineReasonDialogChirp.module.scss'

export interface PrescriptionDeclineReasonDialogClasses {
  button?: string
  cancelButton?: string
  declineButton?: string
}

export interface PrescriptionDeclineReasonDialogProps {
  classes?: PrescriptionDeclineReasonDialogClasses
  onClose: () => void
  onDecline: (declineReason: string) => void
  open: boolean
}

const PrescriptionDeclineReasonDialogChirp = ({
  open,
  onClose,
  onDecline,
  classes: classesProp,
}: PrescriptionDeclineReasonDialogProps) => {
  const { t } = useTranslation(['Common', 'Dialogs'])
  const [declineReason, setDeclineReason] = useState('')
  const [error, setError] = useState<string | null>(null)

  const handleDecline = () => {
    if (!declineReason.trim()) {
      setError(
        t('Dialogs:PRESCRIPTION_DECLINE_REASON_DIALOG.REQUIRED_FIELD_ERROR'),
      )
      return
    }
    setError(null)
    onDecline(declineReason)
    onClose()
    setDeclineReason('')
  }

  const handleCancel = () => {
    setError(null)
    setDeclineReason('')
    onClose()
  }

  const controls = () => (
    <div className={styles.controlsContainer}>
      <KibButtonNew
        className={classNames(
          styles.declineButton,
          classesProp?.button,
          classesProp?.declineButton,
        )}
        emphasis="primary"
        onClick={handleDecline}
      >
        {t('Common:DECLINE_ACTION')}
      </KibButtonNew>
      <KibButtonNew
        className={classNames(
          styles.cancelButton,
          classesProp?.button,
          classesProp?.cancelButton,
        )}
        emphasis="secondary"
        onClick={handleCancel}
      >
        {t('Common:CANCEL_ACTION')}
      </KibButtonNew>
    </div>
  )

  return (
    <KibModal
      className={styles.modal}
      controls={controls}
      open={open}
      title={t('Dialogs:PRESCRIPTION_DECLINE_REASON_DIALOG.TITLE')}
      onClose={handleCancel}
    >
      <KibTextarea
        invalid={Boolean(error)}
        label={t('Dialogs:PRESCRIPTION_DECLINE_REASON_DIALOG.REASON_LABEL')}
        messagesContent={error ? <p>{error}</p> : undefined}
        placeholder={t(
          'Dialogs:PRESCRIPTION_DECLINE_REASON_DIALOG.PLACEHOLDER',
        )}
        value={declineReason}
        onChange={(e) => {
          setDeclineReason(e.target.value)
          if (error) {
            setError(null)
          }
        }}
      />
    </KibModal>
  )
}

export default PrescriptionDeclineReasonDialogChirp
